var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "imageContainer", staticClass: "lc-project-winner-images" },
    [
      _vm.winnerItems && _vm.winnerItems.length > 1
        ? _c(
            "div",
            {
              ref: "projectCarousel",
              class: ["lc-project-carousel", "lc-project-show-carousel"]
            },
            _vm._l(_vm.winnerItems, function(winnerItem, index) {
              return _c(
                "div",
                { key: index, staticClass: "slider-img-cont" },
                [
                  _vm._l(winnerItem.images, function(image) {
                    return image.is_cover == 1
                      ? _c("div", { staticClass: "image-container" }, [
                          _c("img", {
                            attrs: { src: image.image },
                            on: {
                              load: _vm.loaded,
                              click: function($event) {
                                return _vm.navigate(winnerItem.life_details_url)
                              }
                            }
                          })
                        ])
                      : _vm._e()
                  }),
                  _c("div", { staticClass: "textbox" }, [
                    winnerItem.life_challenge_total_winner
                      ? _c("h3", { staticClass: "red" }, [
                          _vm._v(
                            _vm._s(_vm.trans("life_challenge_award_winner"))
                          )
                        ])
                      : _c("h3", { staticClass: "red" }, [
                          _vm._v(
                            _vm._s(_vm.trans("lifechallenge_category_winner"))
                          )
                        ]),
                    _c("h3", { staticClass: "black" }, [
                      _vm._v(_vm._s(winnerItem.life_challenge_project_name))
                    ])
                  ]),
                  _c("div", { staticClass: "badge-winner" }, [
                    winnerItem.life_challenge_total_winner
                      ? _c("img", {
                          attrs: {
                            src: "/images/lc/03_award_winner.png",
                            alt: ""
                          }
                        })
                      : _c("img", {
                          attrs: { src: "/images/lc/02_category_winner.png" }
                        })
                  ])
                ],
                2
              )
            }),
            0
          )
        : _vm._e(),
      _vm.winnerItems && _vm.winnerItems.length > 1
        ? _c(
            "div",
            {
              staticClass:
                "lc-project-slider-arrow lc-project-slider-arrow-right",
              on: {
                click: function($event) {
                  return _vm.next()
                }
              }
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("keyboard_arrow_right")
              ])
            ]
          )
        : _vm._e(),
      _vm.winnerItems && _vm.winnerItems.length > 1
        ? _c(
            "div",
            {
              staticClass:
                "lc-project-slider-arrow lc-project-slider-arrow-left",
              on: {
                click: function($event) {
                  return _vm.prev()
                }
              }
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("keyboard_arrow_left")
              ])
            ]
          )
        : _vm._e(),
      _vm._l(_vm.winnerItems, function(winnerItem, index) {
        return _vm.winnerItems && _vm.winnerItems.length == 1
          ? _c(
              "div",
              {
                class: [
                  "lc-project-main-image",
                  { "lc-project-hide-main": _vm.showCarousel }
                ]
              },
              [
                _vm._l(winnerItem.images, function(image) {
                  return image.is_cover == 1
                    ? _c("div", { staticClass: "image-container" }, [
                        _c("img", {
                          attrs: { src: image.image },
                          on: {
                            load: _vm.loaded,
                            click: function($event) {
                              return _vm.navigate(winnerItem.life_details_url)
                            }
                          }
                        })
                      ])
                    : _vm._e()
                }),
                _c("div", { staticClass: "textbox" }, [
                  winnerItem.life_challenge_total_winner
                    ? _c("h3", { staticClass: "red" }, [
                        _vm._v(_vm._s(_vm.trans("life_challenge_award_winner")))
                      ])
                    : _c("h3", { staticClass: "red" }, [
                        _vm._v(
                          _vm._s(_vm.trans("life_challenge_category_winner"))
                        )
                      ]),
                  _c("h3", { staticClass: "black" }, [
                    _vm._v(_vm._s(winnerItem.name))
                  ])
                ]),
                _c("div", { staticClass: "badge-winner" }, [
                  winnerItem.life_challenge_total_winner
                    ? _c("img", {
                        attrs: {
                          src: "/images/lc/03_award_winner.png",
                          alt: ""
                        }
                      })
                    : _c("img", {
                        attrs: { src: "/images/lc/02_category_winner.png" }
                      })
                ])
              ],
              2
            )
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }